import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_MAGENTA } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/on-and-on-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/on-and-on-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/on-and-on-extreme.guitar.json' with { type: 'json' };

export const ON_AND_ON_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'on-and-on',
  baseTitle: "Sunburst",
  description: "Bright NCS opener — Tobu & Itro's Sunburst on [KOR]_Stranger's clean 3-diff mania set. Easy hooks ramp into Hard streams across real chart tiers.",
  difficulty: 1,
  palette: PALETTE_MAGENTA,
  audioSrc: '/audio/guitar/on-and-on.mp3',
  attribution: "\"Sunburst\" by Tobu & Itro [NCS Release] - https://ncs.io/sunburst",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
